import { Box, Grid, Button, TextField } from "@mui/material";
import { FC, useState, useEffect } from "react";
import GoldTopBanner from "components/GoldTopBanner";
import SettingsBackupRestoreOutlinedIcon from "@mui/icons-material/SettingsBackupRestoreOutlined";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import { H3, H4, Small, Tiny } from "../../components/Typography";
import { load, remove } from "../../constants/storage";
import { toast } from "react-hot-toast";
import { useLocation } from "react-router-dom";
import { useAppDispatch } from "../../store/hooks";
import {
  getLivePrices,
  getInvestments,
  getProducts,
} from "../../redux/actions/GoldSilverAction";
import { useNavigate } from "react-router-dom";
import DashboardNavbar from "../../components/DashboardNavbar";
import SilverTopBanner from "../../components/SilverTopBanner";
const SellRedeem: FC = () => {
  let routeData = useLocation();
  const { cardType } = routeData.state;
  const [type, setType] = useState(cardType);
  const [selected, setSelected] = useState<any>(null);
  const [metalType, setMetalType] = useState("Gold");
  const [selectedValue, setSelectedValue] = useState(1);
  const [count, setCount] = useState(1);
  const [goldLivePrice, setGoldLivePrice] = useState<any>();
  const [silverLivePrice, setSilverLivePrice] = useState<any>();
  const [redeemData, setRedeemData] = useState([]);
  //Investment Details
  const [goldGrowth, setGoldGrowth] = useState<any>();
  const [silverGrowth, setSilverGrowth] = useState<any>();
  const [totalGoldAmt, setTotalGoldAmt] = useState();
  const [totalGold, setTotalGold] = useState<any>();
  const [totalSilverAmt, setTotalSilverAmt] = useState();
  const [totalSilver, setTotalSilver] = useState<any>();
  const [goldCurrentValue, setGoldCurrentValue] = useState();
  const [silverCurrentValue, setSilverCurrentValue] = useState();
  //Gold/Silver TextFiled
  const [goldAmount, setGoldAmount] = useState<any>();
  const [silverAmount, setFinalSilverPrice] = useState<any>();
  const [amount, setAmount] = useState<any>();
  const [goldGram, setGoldGram] = useState<string>("1");
  const [silverGram, setSilverGram] = useState<string>("1");
  const [goldPriceWithGst, setGoldPriceWithGst] = useState<any>();
  const [silverPriceWithGst, setSilverPriceWithGst] = useState<any>();
  const [currentIndex, setCurrentIndex] = useState(0);
  let navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [selectedGridRef, setSelectedGridRef] =
    useState<React.RefObject<HTMLDivElement> | null>(null);
  useEffect(() => {
    checkToken();
  }, [metalType]);

  useEffect(() => {
    if (selected && selectedGridRef?.current) {
      selectedGridRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [selected, selectedGridRef]);
  const setRef = (item: any, ref: React.RefObject<HTMLDivElement>) => {
    if (selected === item) {
      setSelectedGridRef(ref);
    }
  };
  const checkToken = async () => {
    let token = await load("token");
    if (token === undefined) {
      remove("userData");
      remove("token");
      toast.success("Session expired, please login again.");
      navigate("/login");
    } else {
      getPrices();
      getInvestmentsData();
      getRedeemProducts();
      setGoldGram("1");
      setSilverGram("1");
      setCount(1);
      setSelectedValue(1);
    }
  };
  useEffect(() => {
    const disableBackAndForward = (event: PopStateEvent) => {
      // This prevents the user from navigating back or forward
      window.history.pushState(null, "", window.location.href);
    };

    // Attach the event listener when the component mounts
    window.addEventListener("popstate", disableBackAndForward);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("popstate", disableBackAndForward);
    };
  }, []);

  //Get Live Prices
  const getPrices = async () => {
    let token = await load("token");
    dispatch(getLivePrices(token))
      .then(async (response: any) => {
        setSilverLivePrice(response.sSell);
        setGoldLivePrice(response.gSell);

        let goldPriceGst = parseFloat(response.gSell);
        setGoldAmount(goldPriceGst.toFixed(2));

        let silverPriceGst = parseFloat(response.sSell);
        setFinalSilverPrice(silverPriceGst.toFixed(2));

        let final =
          metalType === "Gold"
            ? goldPriceGst.toFixed(2)
            : metalType === "Silver"
            ? silverPriceGst.toFixed(2)
            : null;
        setAmount(final);

        if (metalType === "Gold") {
          setGoldPriceWithGst(goldPriceGst.toFixed(2));
          return;
        }
        if (metalType === "Silver") {
          setSilverPriceWithGst(silverPriceGst.toFixed(2));
          return;
        }
        //setLoading(false);
      })
      .catch((error) => {
        toast.error(error);
        // setLoading(false);
      });
  };

  //Get Investments Prices
  const getInvestmentsData = async () => {
    let token = await load("token");
    const countryCode: any = "91";
    let userDetail: any = load("userData");
    let finalUser = JSON.parse(userDetail);
    var numberWithCode = countryCode + finalUser.mobile;
    dispatch(getInvestments(numberWithCode, token))
      .then(async (response: any) => {
        setTotalGold(response?.totalGold.toFixed(4) ?? "0");
        setTotalGoldAmt(response?.totalGoldAmt ?? "0");
        setTotalSilver(response?.totalSilver.toFixed(4) ?? "0");
        setTotalSilverAmt(response?.totalSilverAmt ?? "0");
        setGoldGrowth(response?.goldChangedBy ?? "0");
        setSilverGrowth(response?.silverChangedBy ?? "0");
        setSilverCurrentValue(response?.silverCurrentValue ?? "0");
        setGoldCurrentValue(response?.goldCurrentValue ?? "0");
      })
      .catch((error: any) => {});
  };

  //get Redeem Products
  const getRedeemProducts = async () => {
    var data = metalType === "Gold" ? "gold" : "silver";
    let token = await load("token");
    dispatch(getProducts(data, token))
      .then(async (response: any) => {
        if (response.statusCode === 200) {
          const sortedDesc = response.result.data.sort(
            (objA: any, objB: any) =>
              Number(objA.productWeight) - Number(objB.productWeight)
          );
          let finalData;
          if (metalType === "Gold") {
            finalData = sortedDesc.filter((a: any) => {
              if (a.metalType === "gold") {
                return a;
              }
            });
          } else {
            finalData = sortedDesc.filter((a: any) => {
              if (a.metalType === "silver") {
                return a;
              }
            });
          }
          setRedeemData(finalData);
          // setSelected(finalData[0]);
        }
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };
  const onProceed = () => {
    let finalGoldWeight = Number(selected?.productWeight) * count;
    if (metalType === "Gold") {
      if (finalGoldWeight > totalGold) {
        toast.error("You dont have enough gold");
      } else {
        navigate("/redeemPriceBreakup", {
          state: {
            selected: selected,
            total: totalGold,
          },
        });
      }
    }
    if (metalType === "Silver") {
      if (finalGoldWeight > totalSilver) {
        toast.error("You dont have enough silver");
      } else {
        navigate("/redeemPriceBreakup", {
          state: {
            selected: selected,
            total: totalSilver,
          },
        });
      }
    }
  };

  //Amount Edit
  const amountEdit: React.ChangeEventHandler<
    HTMLInputElement | HTMLTextAreaElement
  > = (event: any) => {
    const value = event.target.value;

    if (value > 100000) {
      toast.error("Amount should not be greater than 100000 rupees.");
      return;
    }
    if (value <= 100000) {
      var totalGram: any = value / amount;
      totalGram = totalGram.toFixed(4);
      if (totalGram <= 500) {
        setGoldGram(totalGram);
        setSilverGram(totalGram);
        setGoldAmount(value);
        setFinalSilverPrice(value);
      } else {
        toast.error("Please enter less then 500 Gm.");
      }
    }
  };

  //Gram Edit
  const grmEdit: React.ChangeEventHandler<
    HTMLInputElement | HTMLTextAreaElement
  > = (event: any) => {
    const value = event.target.value;
    if (value > 500) {
      toast.error("Please enter less then 500 Gm.");
    } else {
      var totalAmmount: any = amount * value;
      totalAmmount = totalAmmount.toFixed(2);
      if (totalAmmount <= 100000) {
        setGoldAmount(totalAmmount);
        setFinalSilverPrice(totalAmmount);
        setGoldGram(value);
        setSilverGram(value);
      } else {
        toast.error("Amount should not be greater then 100000 rupees.");
      }
    }
  };

  const onButtonSelected = (item: number, sellPrice: number = 0) => {
    let tempGoldGrms: any = 0;
    let totalAmmount: any = 0;
    if (metalType === "Gold") {
      if (totalGold > 0) {
        tempGoldGrms = (totalGold * item) / 100;
        tempGoldGrms = tempGoldGrms.toFixed(4);
        totalAmmount = tempGoldGrms * goldLivePrice;
        totalAmmount = totalAmmount.toFixed(2);
      }
      setGoldAmount(totalAmmount);
      setGoldGram(tempGoldGrms);
    } else {
      if (totalSilver > 0) {
        tempGoldGrms = (totalSilver * item) / 100;
        tempGoldGrms = tempGoldGrms.toFixed(4);
        totalAmmount = tempGoldGrms * silverLivePrice;
        totalAmmount = totalAmmount.toFixed(2);
        setFinalSilverPrice(totalAmmount);
        setSilverGram(tempGoldGrms);
      }
    }
  };

  const onSellClick = () => {
    const data = {
      amount: metalType === "Gold" ? goldAmount : silverAmount,
      productId: metalType === "Gold" ? "gold" : "silver",
      quantity: metalType === "Gold" ? goldGram : silverGram,
      currentSellPrice: amount,
    };
    let finalGoldWeight = metalType === "Gold" ? goldGram : silverGram;
    if (metalType === "Gold") {
      if (isNaN(parseFloat(finalGoldWeight)) || isNaN(totalGold)) {
        toast.error("You don't have enough gold.");
        return;
      }
      if (finalGoldWeight > totalGold) {
        toast.error("You dont have enough gold");
        return;
      }
      if (parseFloat(finalGoldWeight) <= 0) {
        toast.error("Please select gold Gm.");
        return;
      }
      navigate("/priceBreakup", {
        state: {
          data: data,
        },
      });
    }
    if (metalType === "Silver") {
      if (isNaN(parseFloat(finalGoldWeight)) || isNaN(totalSilver)) {
        toast.error("You don't have enough silver.");
        return;
      }
      if (finalGoldWeight > totalSilver) {
        toast.error("You dont have enough silver");
        return;
      }
      if (parseFloat(finalGoldWeight) <= 0) {
        toast.error("Please select silver Gm.");
        return;
      }

      navigate("/priceBreakup", {
        state: {
          data: data,
        },
      });
    }
  };

  return (
    <>
      <DashboardNavbar />
      <Box
        sx={{
          background: "#F6F6F6",
          pl: {
            md: 10,
            xs: 2,
            sm: 2,
          },
          pr: {
            md: 10,
            xs: 2,
            sm: 2,
          },
          pb: 2,
          pt: 2,
        }}
      >
        {metalType === "Gold" ? <GoldTopBanner /> : <SilverTopBanner />}
        <Grid
          xs={12}
          md={8}
          sx={{
            padding: {
              md: 1,
              xs: 0,
              sm: 0,
            },
            pl: 2,
            pr: 2,
            height: "100%",
          }}
        >
          <Grid
            sx={{
              backgroundColor: "#fff",
              borderRadius: 2,
            }}
          >
            <Grid
              sx={{
                pt: 0.5,
                pb: 2.5,
                justifyContent: {
                  md: "flex-start",
                  xs: "center",
                  sm: "center",
                },
                paddingLeft: {
                  md: 4,
                  xs: 1,
                  sm: 1,
                },
                paddingRight: {
                  md: 0,
                  xs: 1,
                  sm: 1,
                },
                mt: {
                  xs: 3,
                  sm: 3,
                  md: 1,
                },
              }}
            >
              <H3
                sx={{
                  mt: 1,
                  pb: 1,
                  fontFamily: "'Poppins', sans-serif",
                }}
              >
                Investment Details
              </H3>
              <Box
                sx={{
                  width: {
                    md: "40%",
                  },
                  borderRadius: 2,
                  mt: 2,
                }}
              >
                <Button
                  onClick={() => {
                    setMetalType("Gold");
                  }}
                  disableElevation
                  disableRipple
                  size="medium"
                  sx={{
                    background:
                      metalType === "Gold"
                        ? process.env.REACT_APP_BUTTON_ACTIVE_COLOR
                        : "#F6F6F6",
                    color: metalType === "Gold" ? "#fff" : "#000",
                    width: "50%",
                    borderBottomRightRadius: 0,
                    borderTopRightRadius: 0,
                    borderTopLeftRadius: 10,
                    borderBottomLeftRadius: 10,
                    textTransform: "none",
                    "&:hover": {
                      background:
                        metalType === "Gold"
                          ? process.env.REACT_APP_BUTTON_ACTIVE_COLOR
                          : "#F6F6F6",
                    },
                  }}
                >
                  Digital Gold
                </Button>
                <Button
                  disableElevation
                  disableRipple
                  onClick={() => {
                    setMetalType("Silver");
                  }}
                  size="medium"
                  sx={{
                    background:
                      metalType === "Silver"
                        ? process.env.REACT_APP_BUTTON_ACTIVE_COLOR
                        : "#F6F6F6",
                    color: metalType === "Silver" ? "#fff" : "#000",
                    width: "50%",
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0,
                    borderBottomRightRadius: 10,
                    borderTopRightRadius: 10,
                    textTransform: "none",
                    "&:hover": {
                      background:
                        metalType === "Silver"
                          ? process.env.REACT_APP_BUTTON_ACTIVE_COLOR
                          : "#F6F6F6",
                    },
                  }}
                >
                  Digital Silver
                </Button>
              </Box>
            </Grid>
            <Grid
              sx={{
                display: "flex",
                borderTop: 0.2,
                borderBottom: 1,
                borderColor: "#EEEEEE",
                marginTop: 2,
              }}
            >
              <Grid
                sx={{
                  width: "25%",
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                  flexDirection: "column",
                  borderTopColor: "#EEEEEE",
                  borderTopWidth: 0.2,
                  mt: 0.5,
                  mb: 0.5,
                }}
              >
                <H4
                  color={process.env.REACT_APP_BUTTON_ACTIVE_COLOR}
                  sx={{
                    width: "100%",
                    textAlign: "center",
                  }}
                  fontWeight={"500"}
                >
                  ₹{metalType === "Gold" ? totalGoldAmt : totalSilverAmt}
                </H4>
                <H4
                  sx={{
                    fontFamily: "'Poppins', sans-serif",
                    textAlign: "center",
                  }}
                  color={"#868686"}
                >
                  Total Investment
                </H4>
              </Grid>
              <Grid
                sx={{
                  width: "25%",
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                  flexDirection: "column",

                  borderLeftWidth: "1px", // set the left border width to 2 pixels
                  borderLeftStyle: "solid", // set the left border style to solid
                  borderLeftColor: "#EEEEEE", // set the left border color

                  pt: 2,
                  pb: 2,
                }}
              >
                <H4
                  fontWeight={"500"}
                  color={process.env.REACT_APP_BUTTON_ACTIVE_COLOR}
                  sx={{
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  ₹
                  {metalType === "Gold" ? goldCurrentValue : silverCurrentValue}
                </H4>
                <H4
                  sx={{
                    fontFamily: "'Poppins', sans-serif",
                    textAlign: "center",
                  }}
                  color={"#868686"}
                >
                  Current Amount
                </H4>
              </Grid>
              <Grid
                sx={{
                  width: "25%",
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                  flexDirection: "column",
                  borderColor: "#EEEEEE",
                  borderLeft: 1,
                  borderLeftColor: "#EEEEEE",
                }}
              >
                {metalType === "Gold" ? (
                  <H4
                    color={
                      goldGrowth < 0
                        ? "#f00"
                        : process.env.REACT_APP_BUTTON_ACTIVE_COLOR
                    }
                    sx={{
                      width: "100%",
                      textAlign: "center",
                    }}
                    fontWeight={"500"}
                  >
                    ₹{goldGrowth}
                  </H4>
                ) : (
                  <H4
                    fontWeight={"600"}
                    color={
                      silverGrowth < 0
                        ? "#f00"
                        : process.env.REACT_APP_BUTTON_ACTIVE_COLOR
                    }
                    sx={{
                      width: "100%",
                      textAlign: "center",
                    }}
                  >
                    ₹{silverGrowth}
                  </H4>
                )}
                <H4
                  sx={{
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  color={"#868686"}
                >
                  Returns
                </H4>
              </Grid>
              <Grid
                sx={{
                  width: "25%",
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                  flexDirection: "column",
                  borderLeft: 1,
                  borderLeftColor: "#EEEEEE",
                }}
              >
                <H4
                  fontWeight={"500"}
                  color={process.env.REACT_APP_BUTTON_ACTIVE_COLOR}
                  sx={{
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  {metalType === "Gold" ? totalGold : totalSilver} Gm
                </H4>
                <H4
                  sx={{
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  color={"#868686"}
                >
                  Weight
                </H4>
              </Grid>
            </Grid>
            <Grid
              sx={{
                width: "100%",
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
                flexDirection: "column",
                minHeight: 50,
                p: 2,
              }}
            >
              {metalType === "Gold" ? (
                <H4
                  sx={{
                    fontFamily: "'Poppins', sans-serif",
                    textAlign: "center",
                  }}
                >
                  Gold has delivered an average annual return of 10.9% over the
                  last 10 years
                </H4>
              ) : (
                <H4
                  sx={{
                    fontFamily: "'Poppins', sans-serif",
                    textAlign: "center",
                  }}
                >
                  Silver's average annual return has been 3.7% over the past
                  decade.
                </H4>
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid
          xs={12}
          md={8}
          sx={{
            mt: 2,
            mb: 2,
            height: "100%",
            borderRadius: 2,
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            background: {
              xs: "#fff",
            },
          }}
        >
          <Box
            sx={{
              width: "100%",
              borderRadius: 2,
              pb: 1,

              display: "flex",
              flexDirection: "row",
            }}
          >
            <Button
              onClick={() => {
                setType("Sell");
              }}
              disableElevation
              disableRipple
              size="medium"
              sx={{
                background: type === "Sell" ? "#DD9401" : "#FFFFFF",
                color: type === "Sell" ? "#fff" : "#000",
                width: "50%",
                borderBottomRightRadius: 0,
                borderTopRightRadius: 0,
                borderTopLeftRadius: 10,
                borderBottomLeftRadius: 0,
                pt: 1.5,
                pb: 1.5,
                textTransform: "none",
                "&:hover": {
                  background: type === "Sell" ? "#DD9401" : "#F6F6F6",
                },
              }}
            >
              Sell
            </Button>
            <Button
              disableElevation
              disableRipple
              onClick={() => {
                setType("Redeem");
              }}
              size="medium"
              sx={{
                background: type === "Redeem" ? "#DD9401" : "#FFFFFF",
                color: type === "Redeem" ? "#fff" : "#000",
                width: "50%",
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                borderTopRightRadius: 10,
                textTransform: "none",
                "&:hover": {
                  background: type === "Redeem" ? "#DD9401" : "#F6F6F6",
                },
              }}
            >
              Redeem
            </Button>
          </Box>
          {type === "Sell" && (
            <Box
              sx={{
                padding: {
                  md: 3,
                  xs: 2,
                  sm: 2,
                },
                width: {
                  md: "30%",
                  xs: "90%",
                },
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
                flexDirection: "column",
                m: 2,
                background: "#fff",
                borderRadius: 4,
              }}
            >
              <H4
                color={process.env.REACT_APP_BUTTON_ACTIVE_COLOR}
                fontWeight={"500"}
                sx={{
                  width: "100%",
                  textAlign: "left",
                  mb: 1,
                }}
              >
                Sell {metalType}
              </H4>
              {/* TextInputs */}
              <Box
                sx={{
                  flexDirection: {
                    md: "row",
                    xs: "column",
                  },
                  display: "flex",
                  paddingX: 2,
                  paddingY: 0.5,
                  pb: 2,
                }}
              >
                <Box
                  sx={{
                    flexDirection: "column",
                    width: {
                      xs: "100%",
                      sm: "100%",
                      md: "50%",
                    },
                  }}
                >
                  <H4>Amount</H4>
                  <TextField
                    disabled
                    name="amount"
                    sx={textInputStyles}
                    InputProps={{
                      style: {
                        height: "35px", // change this value to set the desired height
                      },
                    }}
                    onChange={amountEdit}
                    value={metalType === "Gold" ? goldAmount : silverAmount}
                  />
                </Box>
                <Box
                  sx={{
                    flexDirection: "column",
                    width: {
                      xs: "100%",
                      sm: "100%",
                      md: "50%",
                    },
                    mt: {
                      md: 0,
                      sm: 1,
                      xs: 1,
                    },
                  }}
                >
                  <H4>Grams</H4>
                  <TextField
                    name="grams"
                    sx={textInputStyles}
                    InputProps={{
                      style: {
                        height: "35px", // change this value to set the desired height
                      },
                    }}
                    value={metalType === "Gold" ? goldGram : silverGram}
                    onChange={grmEdit}
                  />
                </Box>
              </Box>
              <Grid
                spacing={2}
                sx={{
                  flexDirection: "row",
                  display: "flex",
                  justifyContent: "space-around",
                  alignItems: "stretch",
                  width: "100%",
                  alignSelf: "center",
                  padddingY: 20,
                  pb: 1,
                  cursor: "pointer",
                }}
              >
                {[10, 20, 50, 100].map((item: any, index) => (
                  <Box
                    onClick={() => {
                      setSelectedValue(item);
                      onButtonSelected(item);
                    }}
                    sx={{
                      background:
                        item === selectedValue ? "#002876" : "#FEF7E3",
                      borderRadius: 2,
                      p: 1,
                      pt: 0.4,
                    }}
                  >
                    <Small
                      fontWeight={"500"}
                      sx={{
                        color: item === selectedValue ? "#fff" : "#000",
                      }}
                    >
                      {item}%
                    </Small>
                  </Box>
                ))}
              </Grid>
              <Small
                sx={{
                  textAlign: "center",
                  width: "100%",
                  marginY: 0.4,
                }}
              >
                {metalType} live price:{" "}
                <Small fontWeight={"500"}>
                  ₹
                  <Small fontWeight={"500"}>
                    {metalType === "Gold" ? goldLivePrice : silverLivePrice}/Gm
                  </Small>
                </Small>
              </Small>
              <Small
                sx={{
                  textAlign: "center",
                  width: "100%",
                  mt: 0.4,
                  mb: 1,
                }}
              >
                Price valid for:{" "}
                <Small fontWeight={"500"} color="#DD9401">
                  05:00 min
                </Small>
              </Small>
              <Box
                sx={{
                  background:
                    "linear-gradient(180deg, #FFF3DB 24.82%, rgba(246, 255, 228, 0) 83.94%)",
                  p: 0.7,
                  pl: 2,
                  pr: 2,
                  borderRadius: 2,
                  flexDirection: "row",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  mt: 0.2,
                  mb: 1,
                }}
              >
                <Box
                  component="img"
                  sx={{
                    height: 15,
                    minwidth: 15,

                    mr: 1,
                    mt: -0.2,
                  }}
                  src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/secure.svg"
                  alt="saas-dasboard-footer"
                />
                <Small fontWeight={"500"}>
                  24K {metalType} with 999 Purity
                </Small>
              </Box>
              <Button
                onClick={onSellClick}
                disableElevation
                disableRipple
                size="medium"
                sx={{
                  background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
                  color: "#fff",
                  width: "50%",
                  mb: 1,
                  textTransform: "none",
                }}
              >
                Proceed
              </Button>
            </Box>
          )}

          {type === "Redeem" && (
            <>
              <Grid
                container
                sx={{
                  pb: 5,
                  pt: 2,
                  justifyContent: "space-between",
                  pl: {
                    md: 4,
                    xs: 4,
                    sm: 1,
                  },
                  pr: {
                    md: 4,
                    xs: 4,
                    sm: 1,
                  },
                  display: "flex",
                }}
              >
                {redeemData.map((item: any, index: number) => (
                  <Box
                    sx={{
                      width: {
                        xs: 120,
                        sm: 120,
                        md: 120,
                      },
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                      display: "flex",
                      borderRadius: 2,
                      mt: {
                        md: 0,
                        xs: 2,
                        sm: 1,
                      },
                      overflow: "hidden",
                      background:
                        selected?.name === item?.name ? "#FFF3DB" : "#fff",
                      boxShadow: 1,
                    }}
                  >
                    <Button
                      disableTouchRipple={true}
                      disableElevation={true}
                      disableRipple={true}
                      onClick={() => {
                        setSelected(item);
                      }}
                      key={item.id}
                      ref={(ref: any) => setRef(item, ref)}
                      sx={{
                        justifyItems: "space-between",
                        display: "flex",
                        flexDirection: "column",
                        p: 0,
                      }}
                    >
                      <Box
                        component="img"
                        sx={{
                          height: 100,
                          minwidth: 100,
                          mt: 0.5,
                          mb: 0.5,
                        }}
                        src={item?.productImages[0]?.url}
                        alt="saas-dasboard-footer"
                      />
                      <Box
                        sx={{
                          background:
                            "linear-gradient(180deg, #FFF3DB 24.82%, rgba(246, 255, 228, 0) 83.94%)",
                          pl: 0.6,
                          pr: 0.6,
                          pt: 1,
                          pb: 1,
                        }}
                      >
                        <H4
                          color="#000000"
                          fontSize={12}
                          fontWeight={"400"}
                          sx={{
                            textAlign: "center",
                            fontFamily: "'Poppins', sans-serif",
                          }}
                        >
                          {item.name}
                        </H4>
                      </Box>
                    </Button>
                  </Box>
                ))}
              </Grid>
              {selected ? (
                <Box
                  ref={selectedGridRef}
                  sx={{
                    padding: {
                      md: 3,
                      xs: 2,
                      sm: 2,
                    },
                    width: {
                      md: "40%",
                    },
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                    flexDirection: "column",
                    m: 2,
                    borderRadius: 4,
                    background: "#fff",
                    boxShadow: 2,
                  }}
                >
                  <H4
                    color="#E09A09"
                    fontWeight={"500"}
                    sx={{
                      width: "100%",
                      textAlign: "left",
                      mb: 1,
                    }}
                  >
                    Redeem your {metalType}
                  </H4>
                  {/* TextInputs */}
                  <Box
                    sx={{
                      flexDirection: {
                        md: "row",
                        xs: "column",
                      },
                      display: "flex",
                      paddingX: 2,
                      paddingY: 0.5,
                      pb: 2,
                    }}
                  ></Box>
                  <Grid
                    spacing={2}
                    sx={{
                      flexDirection: "row",
                      display: "flex",
                      justifyContent: "space-around",
                      alignItems: "stretch",
                      width: "100%",
                      alignSelf: "center",
                      padddingY: 20,
                      pb: 1,
                    }}
                  >
                    <Box
                      component="img"
                      sx={{
                        height: 100,
                        minwidth: 100,
                        mt: 0.5,
                      }}
                      src={selected.productImages[0].url}
                      alt="saas-dasboard-footer"
                    />
                  </Grid>
                  <H3
                    sx={{
                      fontFamily: "'Poppins', sans-serif",

                      pt: 2,
                    }}
                  >
                    {selected.name}
                  </H3>
                  <Tiny
                    color="#858585"
                    sx={{
                      mb: 0.2,
                      mt: 0.6,
                      width: "100%",
                      textAlign: "center",
                    }}
                  >
                    Elegance And Beauty Form A Striking Combination In This
                    Gorgeous {metalType} Coin.
                  </Tiny>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mt: 2,
                      mb: 1,
                      width: "100%",
                    }}
                  >
                    <Small
                      sx={{
                        width: {
                          md: "50%",
                          xs: "100%",
                        },
                        mt: 0.4,
                        mb: 1,

                        fontSize: 12,
                      }}
                      fontWeight={"650"}
                      color="#0C0C0C"
                    >
                      <Small
                        sx={{
                          width: {
                            md: "50%",
                            xs: "100%",
                          },
                          mt: 0.4,
                          mb: 1,
                          fontFamily: "'Poppins', sans-serif",
                          fontSize: 12,
                        }}
                        fontWeight={"600"}
                        color="#0C0C0C"
                      >
                        Delivery & making charges:
                      </Small>{" "}
                      ₹{" "}
                      <Small
                        sx={{
                          width: {
                            md: "50%",
                            xs: "100%",
                          },
                          mt: 0.4,
                          mb: 1,
                          fontFamily: "'Poppins', sans-serif",
                          fontSize: 12,
                        }}
                        fontWeight={"600"}
                        color="#0C0C0C"
                      >
                        {selected?.basePrice}
                      </Small>
                    </Small>
                    <Small
                      sx={{
                        textAlign: "right",
                        width: {
                          md: "50%",
                          xs: "100%",
                        },
                        mt: 0.4,
                        mb: 1,
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: 12,
                      }}
                      fontWeight={"600"}
                      color="#0C0C0C"
                    >
                      Model No: {selected.sku}
                    </Small>
                    {/* <Small
                      sx={{
                        textAlign: "right",
                        width: {
                          md: "50%",
                          xs: "100%",
                        },
                        mt: 0.4,
                        mb: 1,
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: 12,
                      }}
                      fontWeight={"600"}
                      color="#0C0C0C"
                    >
                      Metal Weight: {selected.productWeight} Gm
                    </Small> */}
                  </Box>

                  <Box
                    textAlign="center"
                    alignItems="center"
                    sx={{
                      flexDirection: {
                        md: "row",
                        xs: "column",
                      },
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <Box
                      sx={{
                        flexDirection: "row",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <CheckOutlinedIcon style={{ color: "#DD9401" }} />
                      <Small
                        color="#858585"
                        fontWeight={"400"}
                        sx={{
                          width: "100%",
                          textAlign: "left",
                          fontSize: 12,
                          fontFamily: "'Poppins', sans-serif",
                          ml: 1,
                        }}
                      >
                        Certified {metalType} Coins
                      </Small>
                    </Box>
                    <Box
                      sx={{
                        flexDirection: "row",
                        display: "flex",
                        alignItems: "center",
                        mt: {
                          xs: 1,
                        },
                      }}
                    >
                      <ShoppingCartOutlinedIcon style={{ color: "#DD9401" }} />
                      <Small
                        color="#858585"
                        fontWeight={"400"}
                        sx={{
                          width: "100%",
                          textAlign: "left",
                          fontSize: 12,
                          fontFamily: "'Poppins', sans-serif",
                          ml: 1,
                        }}
                      >
                        Secured Delivery
                      </Small>
                    </Box>
                    <Box
                      sx={{
                        flexDirection: "row",
                        display: "flex",
                        alignItems: "center",
                        mt: {
                          xs: 1,
                        },
                      }}
                    >
                      <SettingsBackupRestoreOutlinedIcon
                        style={{ color: "#DD9401" }}
                      />
                      <Small
                        color="#858585"
                        fontWeight={"400"}
                        sx={{
                          width: "100%",
                          textAlign: "left",
                          fontSize: 12,
                          fontFamily: "'Poppins', sans-serif",
                          ml: 1,
                        }}
                      >
                        No returns on coins
                      </Small>
                    </Box>
                  </Box>

                  <Button
                    onClick={onProceed}
                    disableElevation
                    disableRipple
                    size="medium"
                    sx={{
                      background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
                      color: "#fff",
                      width: "50%",
                      mb: 1,
                      mt: 2,
                      textTransform: "none",
                    }}
                  >
                    Proceed
                  </Button>
                </Box>
              ) : null}
            </>
          )}
        </Grid>
      </Box>
    </>
  );
};

export default SellRedeem;
const textInputStyles = {
  width: {
    xs: "100%",
    sm: "100%",
    md: "94%",
  },
  marginTop: {
    xs: 0.5,
    sm: 2,
    md: 0.5,
  },
  padding: 0.2,
};
